import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_URLS } from "src/routes";

import { SEARCH_ENTITY_TYPE } from "@shared-kernel/application/ports/admin/admin-repository";
import { useAdminGlobalSearch } from "@user-management-context/primary/shared/admin-global-search/use-admin-global-search";
import { AdminGlobalSearchContent } from "@user-management-context/primary/shared/admin-global-search/admin-global-search.content";

const ENTITY_ROUTES: Record<SEARCH_ENTITY_TYPE, string> = {
  [SEARCH_ENTITY_TYPE.STUDENT]: ADMIN_URLS.student.detail,
  [SEARCH_ENTITY_TYPE.TEACHER]: ADMIN_URLS.teacher.detail,
  [SEARCH_ENTITY_TYPE.PROVIDER]: ADMIN_URLS.provider.detail,
};

const getEntityUrl = (entityType: SEARCH_ENTITY_TYPE, entityId: string) => {
  return ENTITY_ROUTES[entityType].replace(":id", entityId);
};

export const AdminGlobalSearch = () => {
  const { query, setQuery, results, isLoading } = useAdminGlobalSearch();
  const navigate = useNavigate();

  const handleSelectResult = useCallback(
    (entityType: SEARCH_ENTITY_TYPE, entityId: string) => {
      navigate(getEntityUrl(entityType, entityId));
    },
    [navigate],
  );

  return (
    <AdminGlobalSearchContent
      query={query}
      onQueryChange={setQuery}
      results={results}
      isLoading={isLoading}
      onSelectResult={handleSelectResult}
      getEntityUrl={getEntityUrl}
    />
  );
};
